import * as React from 'react';
import * as LabelPrimitive from '@radix-ui/react-label';
import { cva, type VariantProps } from 'class-variance-authority';
import { cltw } from '../../utils';

export const labelVariants = cva('font-normal leading-none', {
  variants: {
    variant: {
      placeholder:
        'pointer-events-none absolute left-2 top-[6px] z-10 block px-2 text-[10px] text-gray-60 transition-all duration-300 peer-placeholder-shown:top-[18px] peer-disabled:text-gray-60 peer-placeholder-shown:text-[14px] peer-focus:top-[6px] peer-focus:text-[10px] dark:text-white/70',
    },
  },
});

/**
 * @description Shadcn Label
 * @documentation https://ui.shadcn.com/docs/components/label
 */
const Label = React.forwardRef<
  React.ElementRef<typeof LabelPrimitive.Root>,
  React.ComponentPropsWithoutRef<typeof LabelPrimitive.Root> &
    VariantProps<typeof labelVariants>
>(({ className, variant, ...props }, ref) => (
  <LabelPrimitive.Root
    className={cltw(labelVariants({ variant }), className)}
    ref={ref}
    {...props}
  />
));
Label.displayName = LabelPrimitive.Root.displayName;

export { Label };
